import React from 'react';
import { COLORS } from '@app/constants';
import { useTranslation } from 'react-i18next';
import { Text, View } from '@/styles/reactnative';
import { QuantityCosts } from '../styles';
import styled from 'styled-components';
import { RxDividerVertical } from 'react-icons/rx';

const QuantityCostFormList = ({ title, bids, asks, type }) => {
  const { t } = useTranslation();

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Text
        style={{
          color: '#B5B5BC',
          fontSize: 12,
          fontFamily: 'NanumSquareRound',
          letterSpacing: '-0.36px',
        }}
      >
        {/*{title && t(title)}*/}
        {title}
      </Text>

      <ValueWrap>
        <QuantityCosts>
          <Text
            style={{
              color: COLORS.lightGreen,
              fontSize: 12,
              fontFamily: 'NanumSquareRound',
              letterSpacing: '-0.36px',
            }}
          >
            {bids}
          </Text>
          <div
            style={{
              width: '1px',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              height: '10px',
              position: 'relative',
              bottom: '1px',
            }}
          />
          <Text
            style={{
              color: COLORS.lightRed,
              fontSize: 12,
              fontFamily: 'NanumSquareRound',
              letterSpacing: '-0.36px',
            }}
          >
            {asks}
          </Text>
        </QuantityCosts>

        <Text
          style={{
            fontSize: 12,
            fontFamily: 'NanumSquareRound',
            letterSpacing: '-0.36px',
            color: '#fff',
          }}
        >
          {type}
        </Text>
      </ValueWrap>
    </View>
  );
};

export default QuantityCostFormList;

const ValueWrap = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;
